import React from "react";
import { ACTION_FORM_TYPE } from "config/constants";
import ActionLayout from "../ActionLayout";

const ProductAttributeCreate = () => {
  return <ActionLayout type={ACTION_FORM_TYPE.CREATE} />;
};

export default ProductAttributeCreate;
